import { http } from "config/http";
import * as myConst from "../constants/index"
import { http93 } from "config/http93";
import { http7001 } from "config/http7001";
import { toast } from "react-toastify";

export const getConversationsList = async () => {
    try {
        const res: any = await http.get(`conversation?offset_limit=${0}&user_name=${localStorage.getItem("username")}&limit=${500}&client_env=${localStorage.getItem("clientName")}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}


export const getConversation = async (id: any) => {
    try {
        const res: any = await http.get(`conversation_v1/${id}?client_env=${localStorage.getItem("clientName")}`)
        return res?.data
    } catch (error) {
        return error
    }
}

export const getUploadedDoc = async (id: string, username:string) => {
    try {
        const res: any = await http.get(`conversation_v2/${id}?conversation_id=${id}&client_env=${localStorage.getItem("clientName")}&user_name=${username}`)
        return { result: res?.data }
    } catch (error: any) {

        return { error: error.message }
    }
}

export const deleteConversation = async (id: any) => {
    try {
        const res: any = await http.put(`/conversations/update_DeleteFlag`, { conversation_id: id, client_env: localStorage.getItem("clientName") })
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const editConversationTitle = async (body: any) => {
    const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
    try {
        const res: any = await http.put(`conversations/updateTitle`, destinationObject)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const isLikeConversation = (body: any) => {
    const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
    try {
        const res = http.post(`conversation/message_feedback`, destinationObject)
        return res
    } catch (error) {
        return error
    }
}

export const dislikeConversation = async (body: any) => {
    const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
    try {
        const res = await http.post(`conversation/message_feedback`, destinationObject)
        return { result: res?.data }
    } catch (error) {
        return { error: error };
    }
}

export const login = async (username: any, password: any) => {
    try {
        const res = await http.post('login_and_introspect', {
            user_name: username,
            password: password,
            client_env: localStorage.getItem("clientName")
        })
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message };
    }
}

export const signup = async (body: any) => {
    try {
        const res = await http.post('user_registration_with_admin_token', {
            first_name: body.firstName,
            last_name: body.lastName,
            email: body.email,
            password: body.password,
            client_env: localStorage.getItem("clientName")
        })
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message };
    }
}

export const logout = async (body: any) => {
    try {
        const res = await http.post('logout', {
            refresh_token: body,
            client_env: localStorage.getItem("clientName")
        })
        return { result: res?.data };
    } catch (error: any) {
        return { error: error.message };
    }
}

export const startConversation = async (body: any) => {
    const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
    try {
        const response: any = await http.post("conversation/start_v1", destinationObject)
        const answer = await response?.data;
        return answer
    } catch (error) {
        return error
    }
}

export const startConversation_v2 = async (body: any) => {
    try {
        const startTime = new Date().getTime();
        const response: any = await http93.post("conversation/start_v2", body.file, {
            params: {
                query: body.query,
                user_name: body.user_name,
                conversation_id: body.conversation_id,
                on_the_fly: body.on_the_fly,
                model: body.model,
                client_env: localStorage.getItem("clientName")
            }
        })
        const answer = await response?.data;
        const endTime = new Date().getTime();
        const duration = endTime - startTime;
        return { result: { ...answer, duration: duration } }
    } catch (error: any) {
        return { error: error.message }
    }
}


export const getLanguage = async(body:any) => {
    try {
        const response : any = await http7001.post("pdf_check" , body)
        const answer = await response?.data;
        return { result: answer }
    } catch (error : any) {
        return { error: error.message }
    }
}


// export const startConversation_upload_v2 = async (body: any) => {
//     try {
//         const response: any = await http93.post("conversation/start_v2", body.file, {
//             params: {
//                 query: body.query,
//                 user_name: body.user_name,
//                 conversation_id: body.conversation_id,
//                 on_the_fly: body.on_the_fly,
//                 model: body.model,
//                 client_env: localStorage.getItem("clientName")
//             }
//         })
//         const answer = await response?.data;
//         return { result: answer }
//     } catch (error: any) {
//         return { error: error.message }
//     }
// }

export const getOTP = async (body: any) => {
    try {
        const res = await http.post('send_otp', {
            email: body,
            client_env: localStorage.getItem("clientName")
        })
        return { result: res?.data };
    } catch (error: any) {
        return { error: error.message }
    }
}
export const validateOTP = async (body: any) => {
    try {
        const res = await http.post('validate_otp', {
            email: body.email,
            otp: body.otp,
            client_env: localStorage.getItem("clientName")
        })
        return { result: res?.data };
    } catch (error: any) {
        return { error: error.message }
    }
}
export const forgotPassword = async (body: any) => {
    try {
        const res = await http.post('forgot_password', {
            email: body.email,
            updated_password: body.password,
            client_env: localStorage.getItem("clientName")
        })
        return { result: res?.data };
    } catch (error: any) {
        return { error: error.message }
    }
}
export const changePassword = async (body: any) => {
    try {
        const res = await http.post('reset_password', {
            email: body.email,
            old_password: body.oldPassword,
            new_password: body.newPassword,
            client_env: localStorage.getItem("clientName")
        })
        return { result: res?.data };
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getVerifiedEmail = async (body: any) => {
    try {
        const res = await http.post(`email_verify?user_name=${body}&client_env=${localStorage.getItem("clientName")}`)
        return { result: res?.data };
    } catch (error: any) {
        return { error: error.message }
    }
}


export const documateComparison = async (body: any) => {
    try {
        const res = await http93.post(`document_comparison?client_env=${localStorage.getItem("clientName")}&query=${body.query}&user_name=${body.user_name}${body.c_id !== null ? `&conversation_id=${body.c_id}` : ""}`, {
            file1: body.file1,
            file2: body.file2,
        }, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
        )
        return { result: res?.data };
    } catch (error: any) {
        return { error: error.message }
    }
}

interface date_type_users {
    from_date: string | null,
    to_date: string | null,
    client_env: string | null,
    users_list?: string[]
}

export const getUsersData = async (dates: date_type_users) => {
    try {
        const res = await http.post(`get_users_data`, dates)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

interface date_type_conversation {
    start_date: string,
    end_date: string,
    user_name: string,
    offset: number,
    limit: number,
    client_env: string | null
}

export const getConversationData = async (dates: date_type_conversation) => {
    try {
        const res = await http.get(`get_conversations_data?start_date=${dates.start_date}&end_date=${dates.end_date}&user_name=${dates.user_name}&offset=${dates.offset}&limit=${dates.limit}&client_env=${dates.client_env}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}